import { render, staticRenderFns } from "./compositeCheckItems.vue?vue&type=template&id=94d1c5dc&scoped=true&"
import script from "./compositeCheckItems.vue?vue&type=script&lang=js&"
export * from "./compositeCheckItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d1c5dc",
  null
  
)

export default component.exports